<template>
    <Card class="layout-card" style="height: 100%;">
        <div style="display:flex;justify-content: space-between;margin-bottom: 10px;flex-shrink: 0;">
            <div class="search-form">
                <Input :maxlength="100" v-model="searchForm.id" placeholder="请输入ID" />
                <Input :maxlength="100" v-model="searchForm.recommendName" placeholder="请输入推荐配置名称" />
                <div>
                  <Select style="width: 140px;" v-model="searchForm.langId" placeholder="请选择语言">
                    <Option v-for="(item,index) in langList" :key="index" :value="item.id">{{ item.chineseLangName }}</Option>
                </Select>
                </div>
                <div>
                  <Select style="width: 150px;" v-model="searchForm.recommendChannel" placeholder="请输选择应用渠道" clearable>
                    <Option :value="0">APP</Option>
                    <Option :value="1">WEB</Option>
                  </Select>
                </div>
                <Button type="primary" v-if="buttonMenu['/recommend/view']" @click="getData()">查询</Button>
                <Button @click="handleReset()">重置</Button>
            </div>
            <div><Button type="primary" v-if="buttonMenu['/recommend/add']" @click="handleOpenEditModal()">新增</Button></div>
        </div>
        <div style="height: 100%;overflow:auto">
        <Table :data="tableData" :columns="columns">
            <template #isDefault="{ row }">
            <div>
              <i-switch v-if="buttonMenu['/recommend/default']" :value="row.recommendDefault" :before-change="()=>handleChangeDefault(row)" @on-change="row.recommendDefault=$event"></i-switch>
            <span v-else>{{ row.recommendDefault?'是':'否' }}</span>
            </div>
            </template>
            <template #action="{ row }">
                <div>
                    <a style="margin-left: 10px;" v-if="buttonMenu['/recommend/list/edit']" @click="handleOpenModal(row)">编辑短剧列表</a>
                    <a style="margin-left: 10px;" v-if="buttonMenu['/recommend/edit']" @click="handleOpenEditModal(row)">编辑</a>
                    <!-- <a style="margin-left: 10px;" @click="handleOpenEditModal(row)" disabled>复制</a> -->
                    <Poptip confirm title="确定要删除吗？" v-if="buttonMenu['/recommend/delete']" transfer @on-ok="handleDel(row)"><a
                            style="margin-left: 10px;color: red">删除</a></Poptip>

                </div>
            </template>
            <Pages slot="footer" :page="page" :func="getData"></Pages>
        </Table>
        </div>

        <Modal v-model="editVisible" :title="(form.id ? '编辑' : '新增') + '推荐配置'">
            <Form @submit.native.prevent v-if="editVisible" :label-width="120" :model="form" ref="formRef">
                <FormItem label="推荐配置名称：" placeholder="请输入推荐配置名称 " prop="recommendName"
                    :rules="[{ required: true, message: '请输入推荐配置名称 ' }]">
                    <Input :maxlength="100" v-model="form.recommendName" />
                </FormItem>
                <!-- <FormItem label="排序值：" prop="theaterSort" placeholder="请输入排序值"
                    :rules="[{ required: true, message: '请输入排序值' }]">
                    <InputNumber :min="0" v-model="form.theaterSort" />
                </FormItem> -->
                <FormItem label="应用渠道：" :rules="[{ required: true, message: '请选择应用渠道' }]" prop="recommendChannel">
                  <Select v-model="form.recommendChannel">
                    <Option :value="0">APP</Option>
                    <Option :value="1">WEB</Option>
                  </Select>
                </FormItem>
                <FormItem label="所属语言：" prop="langId" :rules="[{required:true,message:'请选择所属语言'}]">
                    <Select v-model="form.langId" placeholder="请选择语言">
                      <Option v-for="(item,index) in langList" :key="index" :value="item.id">{{ item.chineseLangName }}</Option>
                  </Select>
                </FormItem>
                <FormItem label="是否默认：" prop="recommendDefault">
                    <i-switch v-model="form.recommendDefault" />
                </FormItem>
                <!-- <FormItem prop="theaterStyle" :rules="[{ required: true, message: '请选择频道' }]">
                    <template #label>

                        频道：
                    </template>
                    <Select placeholder="请选择频道" v-model="form.theaterStyle" clearable>
                        <Option :value="0">男频</Option>
                    </Select>
                </FormItem> -->
            </Form>
            <template #footer>
                <Button @click="editVisible = false">取消</Button>
                <Button type="primary" :loading="submitLoading" @click="handleSubmit()">提交</Button>
            </template>
        </Modal>
        <Modal v-model="visible" title="编辑短剧列表" :width="800">
            <movieList v-if="visible" :form="form"></movieList>
        </Modal>
    </Card>
</template>

<script>
import Pages from '@/components/pages'
import style1 from '@/assets/images/style1.png'
import style2 from '@/assets/images/style2.png'
import style3 from '@/assets/images/style3.png'
import style4 from '@/assets/images/style4.png'
import movieList from './components/movie-list.vue'
import { getRecommendList, addRecommend, delRecommend, editRecommend, getRecommendInfo } from '@/api/recommend'
import { getLangList } from '../../api/lang'
export default {
  components: {
    Pages,
    movieList
  },
  data() {
    return {
      style1,
      langList: [],
      style2,
      style4,
      style3,
      editVisible: false,
      submitLoading: false,
      visible: false,
      form: {},
      searchForm: {},
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      tableData: [],
      columns: [
        {
          title: 'id',
          key: 'id'
        },
        {
          title: '推荐配置名称',
          key: 'recommendName'
        },
        {
          title: '所属语言',
          key: 'langName'
        },
        {
          title: '应用渠道',
          key: 'recommendChannelName'
        },
        {
          title: '是否默认',
          slot: 'isDefault'
        },
        {
          title: '操作',
          align: 'center',
          width: 300,
          slot: 'action'
        }
      ]
    }
  },
  computed:{
    buttonMenu() {
      const li = this.$store.getters.getMenuRules('server/recommend')
      const obj = {}
      li.forEach(i => {
        obj[i.menuPath] = true
      })
      return obj
    }
  },
  methods: {
    handleChangeDefault(row) {
      editRecommend({
        ...row,
        recommendDefault: !row.recommendDefault
      }).then(r => {
        this.$Message.success('操作成功')
        this.getData(this.page.current)
      }).catch(e => {
        this.$Message.error('操作失败')
      })
      return new Promise(() => {})
    },
    handleGetLang() {
      getLangList({ current: -1, size: -1, langStatus: true }).then(r => {
        this.langList = r.data.records
      })
    },
    getData(page) {
      if (page) this.page.current = page
      else this.page.current = 1
      getRecommendList({
        ...this.page,
        ...this.searchForm
      }).then(({ data }) => {
        console.log(data)

        this.tableData = data.records
        this.page.total = data.total
      })
    },
    async handleOpenEditModal(row) {
      if (row) {
        const r = await getRecommendInfo(row.id)
        this.form = r.data
      } else {
        this.form = {
        //   recommendSort: 0
          recommendDefault:false
        }
      }
      this.editVisible = true
    },
    handleSubmit() {
      this.$refs.formRef.validate(r => {
        if (r) {
          const func = this.form.id ? editRecommend : addRecommend
          this.submitLoading = true
          func({
            ...this.form
          }).then(r => {
            this.$Message.success('操作成功')
            this.getData()
            this.submitLoading = false
            this.editVisible = false
          }).catch(() => {
            this.submitLoading = false
          })
        }
      })
    },
    async handleOpenModal(row) {
      this.form = row
      this.visible = true
    },
    handleDel(row) {
      delRecommend(row.id).then(r => {
        this.$Message.success('操作成功')
        this.getData()
      })
    },
    handleReset() {
      this.searchForm = {}
    }
  },
  mounted() {
    this.getData()
    this.handleGetLang()
  }
}
</script>

<style scoped lang="less">
.search-form {
    display: flex;

    &>* {
        margin: 0 5px;
    }
}

.style-img {
    width: 350px;
}
.layout-card{
  /deep/ .ivu-card-body{
    height: 100%;display:flex;flex-direction: column;
  }
}
</style>
